// extracted by mini-css-extract-plugin
module.exports = {"list":"SocialLinks_list__2ZIjL","link":"SocialLinks_link__1F5eK","label":"SocialLinks_label__X46uO","image":"SocialLinks_image__2zpwH","is_small":"SocialLinks_is_small__gzkNz"};